import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';

interface ICampoDireccionEntregaProps {
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof IDocumento, nuevoValor: IDocumento[keyof IDocumento]) => any;
    valor: string;
}

const CampoDireccionEntrega: FunctionComponent<ICampoDireccionEntregaProps> = ({
    deshabilitado,
    manejarCambioCampo,
    valor,
}) => (
    <TextField
        disabled={deshabilitado}
        fullWidth
        label={<Texto id="FormularioDocumento.CampoDireccionEntrega.Nombre" />}
        onChange={(event) => manejarCambioCampo('DireccionEntrega', event.target.value)}
        value={valor}
        id={`CampoDireccionEntrega-${valor}`}
    />
);

export default CampoDireccionEntrega;
